import React from "react";
import { Check } from "lucide-react";

export default function FlowBar({ step }) {
  const steps = [
    { n:1, l:"Select Event",      id:"events" },
    { n:2, l:"Track Competitors", id:"shows"  },
    { n:3, l:"Review Leads",      id:"leads"  },
    { n:4, l:"Send / Export",     id:"send"   },
  ];
  return (
    <div style={{
      display:"flex", alignItems:"center", gap:0,
      padding:"6px 28px", background:"#fff", borderBottom:"1px solid #D8DADC", flexShrink:0,
    }}>
      {steps.map((s, i) => {
        const active = step === s.n;
        const done   = step > s.n;
        return (
          <React.Fragment key={s.n}>
            <div style={{ display:"flex", alignItems:"center", gap:5 }}>
              <div style={{
                width:22, height:22, borderRadius:"50%",
                background: active ? "#E8431A" : done ? "#22c55e" : "#D8DADC",
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:10, fontWeight:700, color: active||done ? "#fff" : "#818084",
              }}>{done ? <Check size={12} /> : s.n}</div>
              <span style={{
                fontSize:11, fontWeight: active ? 700 : 500,
                color: active ? "#E8431A" : done ? "#16a34a" : "#818084",
              }}>{s.l}</span>
            </div>
            {i < steps.length - 1 && (
              <div style={{ flex:"0 0 40px", height:2, background: done ? "#22c55e" : "#D8DADC", margin:"0 8px" }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
